import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Form from '../forms/Form';
import HamLink from '../forms/HamLink';
import { useGlobalState } from '../stateProvider/StateProvider';
import Card from '../forms/Card';
import Input from '../forms/Input';
import Logo from '../Logo';
import { Regex } from '../utility/regex';
import Copyright from '../layout/Copyright';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import { generateId } from '../utility/functions';
import ModalFactory from '../Modal';

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100svh;
    background: ${({ theme }) => theme.body};
    position: relative;
    z-index: 10;

    animation: ${({ loggedIn }) => loggedIn ? 'riseUp' : 'fallDown'};
    animation-duration: ${({ runAnimation }) => runAnimation ? '1s' : '0s'};
    animation-fill-mode: forwards;
`;
const LogoWrap = styled.div`
    height: 5rem;
`;

const CRight = styled(Copyright)`
    position: absolute;
    bottom: 0;
    right: 0;
`;
const ForgotPW = styled(HamLink)`
    font-size: 0.6em;
`;

const LogIn = ({ ...props }) => {
    const {
        state: {
            active_user,
        },
        logIn,
    } = useGlobalState();

    const [RP, setRP] = useState(false);

    useEffect(() => {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);
        const email = url.searchParams.get('email');
        const token = url.searchParams.get('token');

        if (email && token) {
            setRP(true);
            resetPassword({ token, email });
        }
    }, []);

    const [runAnimation, setRunAnimation] = useState(active_user.isLoggedIn === false);

    useEffect(() => {
        if (active_user.isLoggedIn) return;
        setRunAnimation(true);
    }, [active_user.isLoggedIn])

    const resetPassword = (auth) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Reset Password',
            icon: 'medicalTruck',
            body: (
                <Form
                    inputs={{ password: '' }}
                    onSubmit={(e) => HamQuest.post(QuestRoute.userManagement.resetAccountPassword, {
                        ...e,
                        ...auth
                    })
                        .then(() => {
                            ModalFactory.update({
                                id,
                                title: 'Success',
                                body: 'Password Successfully updated'
                            })
                        })
                    }
                    text='Reset Password'
                    submittingText='Resetting Password'
                >
                    <Input
                        label='Password'
                        name='password'
                        type='password'
                        validate={Regex.test.password}
                        required
                    />
                    <Input
                        label='Confirm Password'
                        name='confirmPass'
                        type='password'
                        confirmation='password'
                        invalidMessage='Passwords must match.'
                        required
                    />
                </Form>
            ),
        })
    }

    const showModal = () => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: 'Recover Email',
            icon: 'medicalTruck',
            form: true,
            body: (
                <Form
                    inputs={{ email: '' }}
                    onSubmit={(e) => HamQuest.getQuery(QuestRoute.forgotPassword, { ...e })
                        .then(() => ModalFactory.update({
                            id,
                            title: 'Success',
                            type: 'success',
                            body: 'Email Sent!'
                        }))
                        .catch(ex => ModalFactory.catch(ex))
                    }
                    text='Recover Password'
                    submittingText='Sending Email'

                    modalForm
                >
                    {({ values }) => (
                        <>
                            <Input
                                label={'Email'}
                                name='email'
                                type='email'
                                validate={Regex.match.email}
                                required
                            />
                        </>
                    )}
                </Form>
            ),
        })
    }



    return (
        <Wrapper
            loggedIn={(active_user.isLoggedIn) ? 1 : 0}
            runAnimation={runAnimation}
        >
            <Card>
                <LogoWrap>
                    <Logo text={true} />
                </LogoWrap>

                <Form
                    inputs={{
                        email: process.env.NODE_ENV !== 'production' ? '' : '',
                        password: process.env.NODE_ENV !== 'production' ? '' : '',
                        rememberMe: true,
                    }}
                    onSubmit={(e) => logIn(e)}

                    text='Log in'
                    submitting='Logging In'
                >
                    <Input
                        label='Email'
                        name='email'
                        type='email'
                        validate={Regex.test.email}
                        placeholder='Email'
                        required
                        autocomplete
                    />
                    <Input
                        label='Password'
                        name='password'
                        type='password'
                        placeholder='Password'
                        required
                        autocomplete
                    />
                </Form>
                <ForgotPW onClick={() => showModal()}>Forgot Password?</ForgotPW>
                {RP && <ForgotPW onClick={() => resetPassword()}>Reset Password</ForgotPW>}
            </Card>
            <CRight />
        </Wrapper>
    );
}

export default LogIn;
